import { render, staticRenderFns } from "./AutoUpdate.vue?vue&type=template&id=d576f9a4&scoped=true"
import script from "./AutoUpdate.vue?vue&type=script&lang=js"
export * from "./AutoUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d576f9a4",
  null
  
)

export default component.exports